import React from "react";
import { Route } from "react-router-dom";

import AdminDashboardLayout from "../../AdminLayout/AdminDashboardLayout/AdminDashboardLayout";
import ADAllTickets from "../Pages/ADAllTickets";
import ADApprovedTickets from "../Pages/ADApprovedTickets";
import ADNewTickets from "../Pages/ADNewTickets";
import ADRejectedTickets from "../Pages/ADRejectedTickets";
import ADAssignedTickets from "../Pages/ADAssignedTickets";
import ADInProgressTickets from "../Pages/ADInProgressTickets";
import ADReadyForReviewTickets from "../Pages/ADReadyForReviewTickets";
import ADAssignToReviewerTickets from "../Pages/ADAssignToReviewerTickets";
import ADReviewInProgressTickets from "../Pages/ADReviewInProgressTickets";
import ADReviewedTickets from "../Pages/ADReviewedTickets";
import ADHoldTickets from "../Pages/ADHoldTickets";
import ADClosedTickets from "../Pages/ADClosedTickets";
import ADReopenTickets from "../Pages/ADReopenTickets";

export const ADTicketsRoutes = (
  <>
    <Route path="/Admin/All-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADAllTickets />} />
    </Route>

    <Route path="/Admin/Unassigned-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADApprovedTickets />} />
    </Route>

    <Route path="/Admin/New-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADNewTickets />} />
    </Route>

    <Route path="/Admin/Rejected-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADRejectedTickets />} />
    </Route>

    <Route path="/Admin/Assigned-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADAssignedTickets />} />
    </Route>

    <Route path="/Admin/In-Progess-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADInProgressTickets />} />
    </Route>

     <Route path="/Admin/Ready-For-Review-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADReadyForReviewTickets />} />
    </Route>

    <Route path="/Admin/Assign-To-Reviewer-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADAssignToReviewerTickets />} />
    </Route>

     <Route path="/Admin/Review-In-Progress-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADReviewInProgressTickets />} />
    </Route>
     
     <Route path="/Admin/Reviewed-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADReviewedTickets />} />
    </Route>

    <Route path="/Admin/Hold-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADHoldTickets />} />
    </Route>

    <Route path="/Admin/Closed-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADClosedTickets />} />
    </Route>

     <Route path="/Admin/Reopen-Tickets" element={<AdminDashboardLayout />}>
      <Route index element={<ADReopenTickets />} />
    </Route>
  </>
);